import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Privacy from './views/PrivacyPolicy'
import Login from './views/Login2'
import Blog from './views/Blog'
import NewBlog from './views/NewBlog'
import Post from './views/Post'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/kitchen',
      name: 'kitchen',
      meta: { requiresAuth: true },
      component: () => import(/* webpackChunkName: "kitchen" */ './views/Kitchen.vue')
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/signup',
      name: 'signup',
      component: Login
    },
    {
      path: '/blog',
      name: 'blog',
      component: Blog
    },
    {
      path: '/newblog',
      name: 'newblog',
      meta: { requiresAuth: true },
      component: NewBlog
    },
    {
      path: '/editpost/:id',
      name: 'editpost',
      meta: { requiresAuth: true },
      component: NewBlog
    },
    {
      path: '/blog/:id',
      name: 'viewpost',
      component: Post
    }
  ]
})
